"use client"; // Added since we’re using state
import React, { useState } from "react";
import HeroPage3 from "../components/HeroPage3";
import { CardParent } from "../../design1/Contact1";
import { ShowMoreText } from "../../design1/About1";
import { BranchType } from "../../design1/components";
import { Switch2 } from "../../design2/components/ButtonSwitch";
import CustomSelect from "../../design1/components/ui/form/CustomSelect";
import { BranchSummaryCard } from "../../design1/Branches";
import { MemberType } from "src/types";
import CardGrid from "../../../CardGrid";
import StyledWraper from "../components/StyledWraper";
import { Card } from "../components/Teams";
import Image from "next/image";
import Link from "next/link";
import { areAllValuesZero } from "../../design1/Staff";
import { useBranchSelection } from "src/app/hooks/useBranchesLogic";

const Branches3 = ({ initialData }: { initialData: BranchType }) => {
  const [activeBranch, setActiveBranch] = useState<1 | 2>(1); // Default is 1
  const {
    selectedValue,
    branchOptions,
    branchDetails,
    handleSelect: handleSelectBranch,
  } = useBranchSelection(initialData);
  return (
    <section className="max-w-full overflow-clip">
      <CustomHero
        text={`Stay Your next move starts here-browse, find, and secure your perfect property today!" Your next move starts here-browse, find, and secure `}
        header="Branches & Staffs"
      />
      <div className="wrapper py-10">
        <div className="first flex gap-10 mb-6 justify-between">
          <Switch2
            button1Text="Branches"
            button2Text="Staff"
            activeState={activeBranch}
            onSwitch={(newState) => setActiveBranch(newState)}
          />
          <div className="p-2 border border-themeColor rounded-md">
            <CustomSelect
              options={branchOptions}
              value={selectedValue}
              onChange={handleSelectBranch}
              placeholder="Select a Branch"
            />
          </div>
        </div>
        {activeBranch === 1 ? (
          <FirstTab branchDetails={branchDetails} />
        ) : (
          <SecondTab members={branchDetails?.staffs} />
        )}
      </div>
    </section>
  );
};

export default Branches3;

const AddressIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 21 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1745 15.1381C12.0475 15.1381 13.5658 13.6197 13.5658 11.7468C13.5658 9.87381 12.0475 8.35547 10.1745 8.35547C8.30154 8.35547 6.7832 9.87381 6.7832 11.7468C6.7832 13.6197 8.30154 15.1381 10.1745 15.1381Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.1724 2.70117C7.7739 2.70117 5.47366 3.65396 3.77768 5.34995C2.0817 7.04593 1.12891 9.34617 1.12891 11.7446C1.12891 13.8834 1.58334 15.2829 2.82456 16.8316L10.1724 25.3099L17.5202 16.8316C18.7614 15.2829 19.2159 13.8834 19.2159 11.7446C19.2159 9.34617 18.2631 7.04593 16.5671 5.34995C14.8711 3.65396 12.5709 2.70117 10.1724 2.70117Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const FirstTab: React.FC<{ branchDetails?: BranchType }> = ({
  branchDetails,
}) => {
  if (!branchDetails) {
    return (
      <p className="font-normal text-lg">
        We’re currently updating our branch details. Soon, you’ll be able to
        view the locations, contact information, and services offered by our
        various branches across the region. Please check back shortly for the
        latest updates.
      </p>
    );
  }
  return (
    <div className="grid-container">
      <About3
        address={branchDetails?.address || ""}
        name={branchDetails?.branchName || ""}
        image={branchDetails?.picture || ""}
        desc={branchDetails?.description}
      />

      {areAllValuesZero(branchDetails?.branchSummary?.values) ? null : (
        <StyledWraper className="!h-max">
          <BranchSummaryCard {...branchDetails?.branchSummary} />
        </StyledWraper>
      )}
    </div>
  );
};
export const SecondTab: React.FC<{ members?: MemberType[] }> = ({
  members,
}) => {
  return (
    <div>
      {members && members.length > 0 ? (
        <CardGrid className="">
          {members.map((item, index) => {
            return (
              <div key={index} className="sm:mx-auto max-w-[300px]">
                <Card {...item} />
              </div>
            );
          })}
        </CardGrid>
      ) : (
        <div>No staff information attached yet. Please try again later.</div>
      )}

      {/* {members && members.length > 0 && (
        <Button className="block mt-12 mx-auto w-max primary-btn">
          Load More
        </Button>
      )} */}
    </div>
  );
};

const About3: React.FC<{
  data?: string;
  image: string;
  address: string;
  name: string;
  title?: string;
  second?: boolean;
  desc?: string;
}> = ({ title, second, desc, image, name, address }) => {
  return (
    <div className="parent mb-6">
      <div className="wra relative">
        <div className="absolute bg-[rgba(var(--primary-color-rgb),0.8)] p-3 bottom-5 left-5 text-white rounded-xl">
          <h3 className="h4">{name}</h3>
          <div className="flex items-center gap-2 ">
            {" "}
            <AddressIcon />{" "}
            <Link
              className="hover:underline capitalize"
              href={`https://maps.google.com/?q=${encodeURIComponent(address)}`}
            >
              {address}
            </Link>{" "}
          </div>
        </div>
        <Image
          height={500}
          width={500}
          className="rounded-xl w-full  object-cover max-h-[330px]"
          src={image}
          alt=""
        />
      </div>

      <StyledWraper className="mt-6">
        <CardParent className="  p-6 ">
          <h4
            className={`title h5 block !font-semibold mb-4 pb-4 border-b  border-b-disabled-main/50 ${
              second && "!border-b-themeColor"
            } text-secondary-main`}
          >
            {title || "About Us"}
          </h4>
          <ShowMoreText text={desc || "Description not available"} />
        </CardParent>
      </StyledWraper>
    </div>
  );
};

export const CustomHero: React.FC<{ header: string; text: string }> = ({
  header,
  text,
}) => {
  return (
    <HeroPage3>
      <div className="flex py-5 md:flex-col justify-between gap-4 w-full">
        <h1 className="whitespace-nowrap">{header}</h1>
        <p className="max-w-2xl h5">{text}</p>
      </div>
    </HeroPage3>
  );
};
